import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import axiosInit from './utils/axiosInit'
import axiosSetHeaderToken from './utils/axiosSetHeaderToken'

axiosInit()

const token = new URLSearchParams(window.location.search).get('token')

if (token) {
  // 1. Store token in Vuex and localStorage
  store.commit('SET_ACCESS_TOKEN', token)
  localStorage.setItem('access_token', token)

  // 2. Attach token to all axios requests
  axiosSetHeaderToken({ token })

  // 3. Decode JWT to get user data
  try {
    const base64Payload = token.split('.')[1]
    const jsonPayload = atob(base64Payload)
    const decoded = JSON.parse(jsonPayload)

    console.log('Decoded JWT from SSO:', decoded)
    console.log('JWT role field:', decoded.role)
    console.log('JWT roles field:', decoded.roles)
    console.log('JWT authorities field:', decoded.authorities)

    const userData = {
      firstName: decoded.firstName || decoded.given_name || '',
      lastName: decoded.lastName || decoded.family_name || decoded.sn || '',
      username: decoded.uid || decoded.sub || decoded.username || '',
      role: decoded.role || decoded.roles || []
    }

    console.log('Setting user data:', userData)
    store.commit('SET_USER_DATA', userData)
  } catch (err) {
    console.error('Failed to decode JWT', err)
    // Force a refresh to properly initialize
    window.location.reload()
  }

  // 4. Dispatch actions exactly as you'd do post-login
  store.dispatch('getGlobalLists')

  // 5. Clean up URL
  window.history.replaceState({}, document.title, window.location.pathname)
} else {
  // Handle token from localStorage on page refresh
  const savedToken = localStorage.getItem('access_token')

  if (savedToken) {
    store.commit('SET_ACCESS_TOKEN', savedToken)

    // Also check for saved user data
    const savedUserData = localStorage.getItem('user_data_token')
    if (savedUserData) {
      try {
        const userData = JSON.parse(savedUserData)
        store.commit('SET_USER_DATA', userData)
      } catch (err) {
        console.error('Failed to parse saved user data', err)
      }
    }

    axiosSetHeaderToken({ token: savedToken })
  }
}

if (store.getters.isLoggedIn) {
  axiosSetHeaderToken({ token: store.state.user.accessToken })
  store.dispatch('getGlobalLists')
}

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
